export const LinkData = [
    {
        id: 'twitter',
        name: 'Twitter Link',
        path: 'https://twitter.com/LucidCode28/',
        title: '',
        target: '_blank',
    },
    {
        id: 'btn__zuri',
        name: 'Zuri Team',
        path: 'https://training.zuri.team/',
        title: '',
        target: '_blank',
    },
    {
        id: 'books',
        name: 'Zuri Books',
        path: 'https://books.zuri.team/',
        title: "You'll fnd books about coding and designs here",
        target: '_blank',
    },
    {
        id: 'book__python',
        name: 'Python Books',
        path: 'https://books.zuri.team/python-for-beginners?ref_id=AlexanderLucid',
        title: "Buy this book to understand the basics of programming with python for WEB,DATA SCIENCE, DATA STRUCTURES AND ALGORITHMS. python is an easy to use programming that allows for various programming dynamics",
        target: '_blank',
    },
    {
        id: 'pitch',
        name: 'Background Check for Coders',
        path: 'https://background.zuri.team/',
        title: "We help organizations recruit the best talents!",
        target: '_blank',
    },
    {
        id: 'book__design',
        name: 'Design Books',
        path: 'https://books.zuri.team/design-rules',
        title: "Download this free design book to become a design heretic",
        target: '_blank',
    },
]